module.exports = __webpack_public_path__ + "img/customer-contact.c319ded8.svg";